"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-table", {
    attrs: {
      data: _vm.tabledata,
      stripe: "",
      border: "",
      height: "400",
      "header-cell-style": {
        color: "#fff",
        fontWeight: "700",
        backgroundColor: "#409eff"
      }
    }
  }, [_c("el-table-column", {
    attrs: {
      type: "index",
      label: "序号",
      width: "50"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "name",
      label: "商户名",
      width: "width"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "num",
      label: "累计交易次数",
      width: "width"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.num) + "次\n      ")];
      }
    }])
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "money",
      label: "累计交易金额",
      width: "width"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.money) + "元\n      ")];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;